import React, { useMemo } from "react";

const DEFAULT_IMAGE = "https://i.postimg.cc/j5PsF5jZ/defaultmovie.png";

const convertDriveUrl = (url) => {
  if (!url) return DEFAULT_IMAGE;

  if (url.includes("drive.google.com")) {
    const match = url.match(/\/d\/(.*?)\//);

    if (match?.[1]) {
      return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w1000`;
    }
  }

  return url;
};

const ImageCard = (props) => {
  const finalUrl = useMemo(
    () => convertDriveUrl(props.img),
    [props.img]
  );

  return (
    <img
      style={{ borderRadius: "10px", objectFit: "cover", ...props.style }}
      width={props.width ?? "200px"}
      height={props.height ?? "280px"}
      src={finalUrl}
      alt={props.alt ?? "Dummy"}
      loading="lazy"
      onError={(e) => {
        // prevent infinite loop
        e.target.onerror = null;

        // only replace once
        if (e.target.src !== DEFAULT_IMAGE) {
          e.target.src = DEFAULT_IMAGE;
        }
      }}
    />
  );
};

export default React.memo(ImageCard);